export default __webpack_public_path__ + "static/media/footstepsicon.ba1c7a0d.svg";